export const isImporterNameDuplicate = (importerName, allImporterNames) => {
    let allNames;
    try{
        allNames = allImporterNames.map(x => String(x.name).toLowerCase().trim())
    } catch (e) {
        allNames = []
    }

    return allNames.includes(importerName.toLowerCase().trim())
}